<template>
    <div class="page-cart">
        <div class="container">
            <div class="oval"></div>
            <div class="page-title">购物车</div>
            <div class="no-cart" v-if="cartList.length>0?false:true">你的购物车为空，请继续浏览。</div>
            <div v-else class="cart-list">
                <div class="cart-item" v-for="(item , index) in cartList" :key="index">
                    <product-item :item="item"></product-item>
                    <div class="item-right">
                        <div class="box">
                            <div>
                                <div class="no-stock" v-if="item.stock === 0">暂无库存</div>
                                <number-change v-else :selectedValue="item.count" :items="item.countOptions" :id="item.id" :change="cartChange"></number-change>
                            </div>
                            <div class="price-box" :class="{'has-dis-price':item.disPrice<item.price}">
                                <div class="price">￥{{item.price/100 * item.count | number_format}}</div>
                                <div class="dis-price">￥{{item.disPrice/100 * item.count | number_format}}</div>
                            </div>
                        </div>
                        <div class="box btn-box">
                            <app-button size="sm" class="remove-btn" @click.native="removeCart(item.id)">移除</app-button>
                        </div>
                    </div>
                </div>
                <div class="summary-box">
                    <div class="item">
                        <b class="label">数量：</b>
                        <span class="value">{{cartSummary.totalQty}}件</span>
                    </div>
                    <div class="item">
                        <b class="label">合计：</b>
                        <span class="value"><em>￥{{cartSummary.disAmounts/100| number_format}}</em></span>
                    </div>
                    <app-button size="md" color="black-solid" :disabled="btnDisabled" class="summary-btn" @click.native="createOrder">结算</app-button>
                </div>
            </div>

            <div class="shop-info-box">
                <div class="shop-info">
                    <div class="oval"></div>
                    <div class="page-title">温馨提示</div>
                    <div class="desc">订单提交之后30分钟内未付款，订单将被系统自动取消，请您尽快完成支付以确保商品能及时送达。</div>
                </div>
                <div class="shop-info">
                    <div class="oval"></div>
                    <div class="page-title">相关问题</div>
                    <div class="desc">
                        <div class="item">
                            <div class="icon-box">
                                <img src="../../assets/images/icon/about/phone.png">
                            </div>
                            <b>如有任何问题，请联系我们 </b>
                            <a href="tel:400(800)-818-6337">400(800)-818-6337</a>
                        </div>
                        <div class="item">
                            <div class="icon-box">
                                <img src="../../assets/images/icon/about/bag.png">
                            </div>
                            <b>退换货服务 </b>
                            <span>您可于 30 天之内享受订单商品的退换货服务。敬请查阅</span>
                            <router-link to="/distribution?pagetype=return">退换货政策</router-link>
                            <span>以获取更多详情。</span>
                        </div>
                        <div class="item">
                            <div class="icon-box">
                                <img src="../../assets/images/icon/about/service.png">
                            </div>
                            <b>配送服务 </b>
                            <span>敬请查阅</span>
                            <router-link to="/distribution?pagetype=distribution">配送及安装</router-link>
                            <span>以获取更多消息。</span>
                        </div>
                        <div class="item">
                            <div class="icon-box">
                                <img src="../../assets/images/icon/about/card.png">
                            </div>
                            <b>支付方式 </b>
                            <span>支付宝、微信支付</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import NumberChange from '../../components/form/NumberChange.vue'
    import ProductItem from '../../components/product/Item.vue'

    export default {
        components: {
            'number-change': NumberChange,
            'product-item': ProductItem
        },
        computed: mapState({
            cartList: state => state.shop.cartList,
            others: state => state.shop.otherCartList,
            cartSummary: state => state.shop.cartSummary
        }),
        data() {
            return {
                btnDisabled: false
            }
        },
        methods: {
            cartChange(num,id) {
                this.$store.dispatch('shop/changeCart',{
                    cartId:id,
                    num:num
                });
            },
            removeCart(id) {
                this.$store.dispatch('shop/removeCart',{
                    cartIdList:[id],
                });
            },
            createOrder(){
                this.$store.dispatch('shop/createOrder');
            }
        },
        created() {
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    @import "../../style/page-common";

    .page-cart {
        padding-top: 60px;
    }

    .summary-box {
        text-align: right;
        .summary-btn {
            margin-top: 50px;
        }
        .item {
            margin: 10px auto;
            .label {

            }
            .value {
                width: 200px;
                display: inline-block;
            }
        }
        em {
            font-size: 16px;
            color: #E2231A;
            font-weight: 700;
            font-style: normal;
        }
    }

    .shop-info-box {
        margin: 150px auto;

    }

    .shop-info {
        font-size: 13px;
        display: inline-block;
        width: 50%;
        vertical-align: top;
        .desc {
            margin-top: 24px;
        }
        .item {
            margin-bottom: 15px;
            .icon-box {
                width: 24px;
                display: inline-block;
                vertical-align: middle;
                margin-right: 16px;
                img {
                    max-width: 24px;
                    max-height: 24px;
                }
            }
            b {
                font-weight: bold;
                font-style: normal;
            }
            span {

            }
            a {
                color: #4A90E2;
            }
        }
    }

    .no-cart {
        font-size: 14px;
        color: #4A4A4A;
        margin-top: 10px;
    }

    $cart-height: 200px;

    .cart-list {
        margin: 20px 0;
        .cart-item {
            border-bottom: 1px solid #F5F5F5;
            @include clearfix;
            .product-item{
                float: left;
            }
            .item-right {
                float: right;
                height: $cart-height;
                .box {
                    float: left;
                    display: flex;
                    height: $cart-height;
                    flex-direction: column;
                    justify-content: center;
                    .price-box{
                        text-align: right;
                        .price {
                            display: inline-block;
                            @include SourceHanSansCN-Bold;
                            color: #C19A77;
                            font-size: 16px;
                            text-align: right;
                        }
                        .dis-price{
                            display: none;
                        }
                        &.has-dis-price{
                            .price{
                                color:#B8B8B8;
                                text-decoration: line-through;
                                font-size: 14px;
                                margin-right: 20px;
                            }
                            .dis-price{
                                display: inline-block;
                                @include SourceHanSansCN-Bold;
                                color: #C19A77;
                                font-size: 16px;
                                text-align: right;
                            }
                        }
                    }

                    &.btn-box {
                        margin-left: 5px;
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.3s ease;
                    }
                }
                .remove-btn {

                }
            }
            &:hover {
                .item-right {
                    .btn-box {
                        opacity: 1;
                        visibility: visible;
                    }
                }

            }
        }
    }
</style>